// @flow
import React, { useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import storage from 'lib/storage';
import { redirectToLogin, redirectToSignup } from 'lib/sso';
import { Forbidden } from 'pages';
import { connect } from 'react-redux';
import type { State } from 'store';
import { compose } from 'redux';
import { UserActions } from 'store/actionCreators';

type Props = {
  // component: React.Component<*,*>,
  // 리액트 컴포넌트의 경우 flow type을 어떻게 해야 에러가 발생하지 않는지 알 수가 없어서 우선 any로 하였습니다.
  component: any,
  path: string,
  exact?: boolean,
};
const PrivateRoute = ({ component: Component, path, exact, ...rest }: Props) => {
  const user = storage.get('__datasee_user__');
  const rule = user && user.rule;

  // props로 넘어오는 유저 rule이 아무것도 없을 때 isRestricted는 false가 되어야 한다.
  // 기본적으로 rest에 2개의 props는 담겨 있다.
  const restProps = Array.from(Object.keys(rest));
  const isRestricted = restProps.length === 3 ? false : restProps.indexOf(rule) <= -1;

  // 로그인과 회원가입의 경우 SSO로 리다이렉트
  if (path === '/login' || path === '/register' || path === '/forgot') {
    if (user) {
      return <Redirect to={'/'} />;
    }
    // SSO 페이지로 리다이렉트
    if (path === '/register') {
      redirectToSignup();
    } else {
      redirectToLogin();
    }
    return null;
  }

  if (rest.success === false) {
    UserActions.checkUser();
    return null;
  }

  // 1. user 정보가 있고, 사용자가 권한이 없는 경우
  // 2. user 정보가 있고, 사용자가 권한이 있는 경우
  // 3. user 정보가 없는 경우(로그인이 되어 있지 않은) - SSO로 리다이렉트
  if (!user) {
    redirectToLogin();
    return null;
  }

  return isRestricted ? (
    <Route component={Forbidden} />
  ) : (
    <Route exact={exact} path={path} component={Component} />
  );
};

export default compose(
  connect(
    ({ pender }: State) => ({
      success: pender.success['user/CHECK_USER'],
    }),
    () => ({}),
  ),
)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/components/privateRoute/PrivateRoute.js